import React from 'react';
import { motion } from 'framer-motion';
import './IndustryDetail.css';

const industryData = {
  'Technology': {
    title: 'Technology & SaaS',
    icon: '💻',
    description: 'We help tech companies scale by optimizing their digital presence for high-intent B2B and B2C audiences.',
    points: ['SaaS Growth Engines', 'Technical SEO for Platforms', 'Lead Gen for Tech Sales'],
    color: '#6366f1'
  },
  'Healthcare': {
    title: 'Healthcare & Wellness',
    icon: '🏥',
    description: 'Building trust and visibility for healthcare providers through patient-centric digital marketing strategies.',
    points: ['HIPAA Compliant Marketing', 'Patient Acquisition Funnels', 'Brand Authority Building'],
    color: '#2dd4bf'
  },
  'E-commerce': {
    title: 'Retail & E-commerce',
    icon: '🛒',
    description: 'Driving sales and increasing AOV for retail brands through precision-targeted performance marketing.',
    points: ['ROAS Optimization', 'Conversion Rate Optimization', 'Omnichannel Strategy'],
    color: '#f43f5e'
  },
  'Real Estate': {
    title: 'Real Estate & Construction',
    icon: '🏗️',
    description: 'Connecting developers and agents with high-value prospects through immersive digital storytelling.',
    points: ['Lead Capture Automation', 'Visual Content Strategy', 'Local Market Dominance'],
    color: '#eab308'
  },
  'Education': {
    title: 'Education & E-learning',
    icon: '🎓',
    description: 'Scaling educational institutions and platforms by reaching students and lifelong learners globally.',
    points: ['Enrollment Growth', 'Educational Content Funnels', 'Platform Visibility'],
    color: '#a855f7'
  }
};

const IndustryDetail = ({ industryName, onBack }) => {
  const data = industryData[industryName] || industryData['Technology'];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.95, y: 20 },
    visible: { 
      opacity: 1, 
      scale: 1,
      y: 0, 
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } 
    }
  };

  return (
    <motion.div 
      className="industry-detail-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      style={{ '--industry-color': data.color }}
    >
      <div className="industry-bg-glow"></div>
      
      <div className="industry-container">
        <motion.button className="back-link" onClick={onBack} variants={itemVariants}>
          ← Back to Discovery
        </motion.button>

        <section className="industry-hero">
          <motion.div className="industry-info" variants={itemVariants}>
            <span className="industry-tag">Sector Expertise</span>
            <h1>{data.title.split(' & ')[0]} <span>& {data.title.split(' & ')[1]}</span></h1>
            <p>{data.description}</p>
            <button className="consult-btn">Get Industry Consultation</button>
          </motion.div>

          <motion.div className="industry-visual" variants={itemVariants}>
            <div className="visual-circle">
              <span className="industry-icon">{data.icon}</span>
            </div>
            <div className="orbit-1"></div>
            <div className="orbit-2"></div>
          </motion.div>
        </section>

        <section className="industry-stats-section">
          <motion.div className="stats-header" variants={itemVariants}>
            <h2>Why Partners in this <span className="text-glow">Sector Trust Us</span></h2>
          </motion.div>
          
          <div className="industry-grid">
            {data.points.map((point, i) => (
              <motion.div key={i} className="industry-card" variants={itemVariants}>
                <div className="card-num">0{i + 1}</div>
                <h3>{point}</h3>
                <p>Meticulously crafted strategies designed to penetrate the competitive {industryName} landscape and deliver measurable ROI.</p>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
    </motion.div>
  );
};

export default IndustryDetail;
